<div class="workersDisplay" #outerElement [class.showCiCoIcon]="showCiCoTypeIcon()">
  <p *ngIf="showAbsent && (visibleWorkers$ | async)?.length > 0">{{'ABSENT_WORKERS' | translate}}</p>
  <mat-grid-list cols="{{columns}}" gutterSize="10">
    <mat-grid-tile class="workerGrid dialog" *ngFor="let worker of visibleWorkers$ | async" [@workerState]="getAnimationState(worker)"
                  [colspan]="1" (click)="openWorkerInfo(worker)" [ngClass]="getCICOTypeClass(worker)">
      <img class="workerPortrait" [src]="worker.userImage.safeSrc" *ngIf="getShowImageSetting() && worker.userImage.safeSrc">
      <img class="attIcon" *ngIf="appService.getInterfaceAttendanceDetailed() && worker._apiData.currentcicotyp"
           [alt]="appService.getCiCoIconTitle(worker)"
           [title]="appService.getCiCoIconTitle(worker)"
           [style.background-color]="appService.getCiCoIconColor(worker)"
           [src]="appService.getCiCoIcon(worker)">
      <div [class.workerName]="getShowImageSetting()">
        {{worker.apiData.caption}}
      </div>
    </mat-grid-tile>
    <mat-grid-tile class="workerGrid dialog" *ngIf="overflowNumber > 0" [colspan]="1" (click)="openWorkerList()">
      <div>
        +{{overflowNumber}}
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
